import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import { generateAndDownloadPdf } from 'helpers/pdf';
import OverlayBackButton from 'components/bolt/overlayBackButton/overlayBackButton';
import Ticket from 'components/bolt/ticket/ticket';
import {
	CONFIRM_CANCEL_ONE,
	CONFIRM_CANCEL_TWO,
	CROSS,
	BACK_TO_TICKET,
	CANCEL_ONE_TICKET,
	CANCEL_UP_TO_TWO_TICKETS,
	CLEAR,
	ENTER_EARLY_ACCESS_CODE,
	TICK,
	SUBMIT_CODE
} from 'helpers/constants';
import TicketAreaButton from 'components/bolt/ticketAreaButton/ticketAreaButton';
import s from 'components/bolt/ticketArea/ticketArea.sss';


export default class TicketArea extends Component {
	constructor(props) {
		super(props);
		this.onBackClick = this.onBackClick.bind(this);
		this.onAddTicket = this.onAddTicket.bind(this);
		this.onDownload = this.onDownload.bind(this);
		this.confirmCancelTicket = this.confirmCancelTicket.bind(this);
	}

	onAddTicket() {
		const copy = this.props?.appData?.copy?.baseCopy || {};
		const { ticketData } = this.props;
		const ticket = ticketData[0];

		Store.emit('SHOW_TICKET_AREA', false);

		const { earlyAccessWindow } = Store.get()?.showtimes;
		if (earlyAccessWindow) {
			Store.emit('SHOW_INFO_SCREEN', {
				type: ENTER_EARLY_ACCESS_CODE,
				ticketIcon: TICK,
				message: copy.$PLEASE_ENTER_YOUR_CODE,
				buttons: [{ text: copy.$SUBMIT, action: SUBMIT_CODE }, { text: copy.$MANAGE_TICKETS, action: BACK_TO_TICKET }],
				onAccessCodeSuccess: () => this.openScreeningInterstitial(ticket),
				screeningId: ticket.screening.id
			});
			return;
		}

		this.openScreeningInterstitial(ticket);
	}

	openScreeningInterstitial(ticket) {
		Store.emit('OPEN_PROVIDER_INTERSTITIAL', {
			screening: {
				...ticket.screening,
				attributes: [],
				link: {}
			},
			theater: ticket.theater,
			mode: 'list'
		});
	}

	onBackClick() {
		Store.emit('SHOW_TICKET_AREA', false);
	}

	onDownload() {
		generateAndDownloadPdf();
	}

	confirmCancelTicket() {
		const { ticketData, appData } = this.props;
		const copy = appData?.copy?.baseCopy || {};

		Store.emit('SHOW_TICKET_AREA', false);
		if (ticketData?.length > 1) {
			Store.emit('SHOW_INFO_SCREEN', {
				type: CONFIRM_CANCEL_TWO,
				ticketIcon: CROSS,
				message: copy.$HOW_MANY_CANCEL,
				buttons: [{ text: copy.$NONE, action: BACK_TO_TICKET, type: CLEAR }, { text: copy.$CONFIRM, action: CANCEL_UP_TO_TWO_TICKETS }]
			});

		} else if (ticketData?.length === 1) {
			Store.emit('SHOW_INFO_SCREEN', {
				type: CONFIRM_CANCEL_ONE,
				ticketIcon: CROSS,
				message: copy.$DO_YOU_WANT_TO_CANCEL,
				buttons: [{ text: copy.$NO, action: BACK_TO_TICKET, type: CLEAR }, { text: copy.$YES, action: CANCEL_ONE_TICKET }]
			});
		}
	}

	render({ show, ticketData, appData, client }) {
		const copy = appData?.copy?.baseCopy || {};
		const showAddTicketButton = ticketData?.length && ticketData.length < 2;
		const screeningSoldOut = ticketData?.[0]?.screening?.soldOut;

		return (
			<div class={joinClasses(s.container, show && s.show)}>
				<OverlayBackButton
					client={client}
					ariaLabel="back"
					onClick={this.onBackClick}
				/>
				<Ticket
					extraClass={s.ticket}
					ticketData={ticketData}
					appData={appData}
				/>
				{showAddTicketButton && screeningSoldOut && <span class={s.soldOut}>{copy.$SCREENING_SOLD_OUT}</span>}
				{showAddTicketButton && <TicketAreaButton text={copy.$ADD_TICKET} onClick={this.onAddTicket} disabled={screeningSoldOut} />}
				<TicketAreaButton text={copy.$DOWNLOAD} onClick={this.onDownload} />
				<TicketAreaButton text={copy.$CANCEL_TICKET} onClick={this.confirmCancelTicket} />
			</div>
		);
	}
}